export default "__VITE_ASSET__DhLQVKLF__"